// app/components/ThemeChanger.js
'use client';
import tcStyles from "./theme-changer-button.module.css"
import sStyles  from "./search-button.module.css"
import { useDispatch, useSelector } from "react-redux"
import { toggleTheme }   from "@/../lib/features/theme/themeSlice"
import { BsMoonFill, BsSearch, BsSunFill } from "react-icons/bs"

export function ThemeChanger() {
    const dispatch = useDispatch()
    const mode     = useSelector(state => state.theme.mode)
    const preference = useSelector(state => state.theme.preference)

    const changeTheme = () => {
        dispatch(toggleTheme())
    }

    const nextMode = mode === "dark" ? "light" : "dark";
    const icon = mode === "dark" ? <BsSunFill /> : <BsMoonFill />;

    return (
        <button
            type="button"
            className={tcStyles.themeChanger}
            onClick={changeTheme}
            aria-label={`Switch to ${nextMode} mode`}
            title={preference === "system" ? "Following system theme" : "Theme set by user preference"}
        >
            {mode === "dark" ? (
                <>
                    <span className={tcStyles["theme-name"]} aria-hidden="true">
                        <span>Light</span> mode
                    </span>
                    <span className={tcStyles["knob"]} aria-hidden="true">
                        {icon}
                    </span>
                </>
            ) : (
                <>
                    <span className={tcStyles["knob"]} aria-hidden="true">
                        {icon}
                    </span>
                    <span className={tcStyles["theme-name"]} aria-hidden="true">
                        <span>Dark</span> mode
                    </span>
                </>
            )}
        </button>
    )
}

export function SearchButton() {
    return (
        <button type="button" className={sStyles.searchButton} aria-label="Search">
            <BsSearch />
        </button>
    )
}
